import { DateOnly } from './date-only';
import { Pagination } from './pagination';
import { AnatomicalSideEnum } from './plan';
import { SearchSortOptions } from './search-sort-options';
import { TspBoneTypeEnum } from './treatment-plan';


/**
 * Patient and case search filters model.
 */
export interface SearchPatientFilters extends Pagination {
	patientNumber?: string;
	caseNumber?: string;
	userId?: string;
	frameID?: string;
	treatmentStatus?: TreatmentStatusType;
	caseSide?: AnatomicalSideEnum;
	caseBone?: TspBoneTypeEnum;
	publishDate?: DateOnly;
	publishDateFilter?: PublishDateFilterType;
	sortOrder?: SearchSortOptions;
}

export enum TreatmentStatusType {
	DRAFTED = 'Drafted',
	PUBLISHED = 'Published',
	REVOKED = 'Revoked'
}

export enum PublishDateFilterType {
	THISDATE = 'ThisDate',
	AFTERDATE = 'AfterDate',
	BEFOREDATE = 'BeforeDate'
}

/**
* Fields of search view
*/
export enum SearchFields {
	patientId = 'PatientNumber',
	patInitials = 'PatientInitials',
	patGender = 'PatientGender',
	lastCasePublish = 'LastCasePublish',
	framePublishCount = 'FramePublishCount'
}